<template>
    <div id="content" class="elabel" :class="[$mq]">
        <template v-if="preview">
            <div class="full-preview">
                <div class="close-preview" @click="fnClosePreview()"></div>
                <div class="preview-container">
                    <div class="gallery-box">
                        <div class="main-image" :class="{ label: selectedPreview == 'label', zpl: isZplPreview }">
                            <ZplPreview
                              v-if="selectedPreview == 'label' && isZplPreview"
                              :data="zpl"
                              :density="density"
                              :width="labelWidth"
                              :height="labelHeight"
                              :values="zplValues"
                              :params="zplParams"
                              :showControls="false"
                              :fitToContainer="true"
                              :previewScale="2"
                              :scale="1"
                              :key="zplKey"
                            />

                            <Preview
                              v-else-if="selectedPreview == 'label'"
                              :data="preview"
                              :maximized="true"
                              ref="previewComp">
                            </Preview>

                            <img v-else :src="selectedPreview" />
                        </div>
                        <div class="thumb-img" v-if="photosOfLabel && photosOfLabel.length > 0 && isSummaryPhoto">
                            <div class="images-boxes label" @click="selectPreview('label')" :class="{ selected: 'label' == selectedPreview }"></div>
                            <div class="images-boxes" v-for="photo in photosOfLabel" @click="selectPreview(photo)" :class="{ selected: photo == selectedPreview }">
                                <img :src="photo" />
                            </div>
                        </div>
                        <template v-if="canReprintLabel && !isExpiredDate(selectedLabel.end_date, selectedLabel.date)">
                            <div v-if="$mq == 'portrait'" class="reprint-button">
                                <Button @on-button-click="reprintLabel()" :contentClass="['content-button', 'expanded']" bType="reprint" :bLabel="$t('button.reprint_label')" />
                            </div>
                        </template>
                    </div>
                    <div class="summary-box">
                        <div class="info-summary">
                            <div class="text-box" :class="{ expand: showMore }">
                                <p class="date">{{ $t('label.print.print_date') }}: {{ displayTraceabilityDate(print_date) }}</p>
                                <p v-if="createdBy" class="date">{{ $t('label.preview.created_by') }}: {{ createdBy }}</p>
                                <p class="date" v-for="summary in selectedLabel.summary" v-if="summary && summary.keyname && summary.keyname != 'photo'">{{ summary.name }}: {{ summary.value }}</p>
                            </div>
                            <div class="show-more-container">
                                <span @click="showMoreOrLess" v-if="$mq.includes(['portrait'])" class="show-more-less">
                                    {{ showMore ? $t('label.less') : $t('label.more') }}
                                </span>
                            </div>
                        </div>
                        <template v-if="canReprintLabel && !isExpiredDate(selectedLabel.end_date, selectedLabel.date)">
                            <div v-if="$mq != 'portrait'" class="reprint-button">
                                <Button @on-button-click="reprintLabel()" :contentClass="['content-button', 'expanded']" bType="reprint" :bLabel="$t('button.reprint_label')" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <header class="header-container">
                <div class="traceability-selector">
                    <Tabs :tabOneText="$t('label.preview.expiration_date')" :tabTwoText="$t('label.preview.print_date')" @switchClick="switchFilter" :selected="filterBy"></Tabs>
                </div>
                <div class="header-actions">
                    <div class="search" :class="{ selected: showFilters }" @click="switchShowFilters()"></div>
                    <button
                        type="button"
                        class="view-mode-toggle"
                        :class="viewMode === 'grid' ? 'view-table' : 'view-grid'"
                        @click="toggleViewMode"
                    >
                        <i v-if="viewMode === 'table'" class="i-andy-convert i-andy-m"></i>
                    </button>
                </div>
            </header>
            <div class="calendar-navigation-container" v-if="!showFilters">
                <calendar-navigation @calendarOpen="calendarState" @select="changeDateCalendar" :selected_date="formatDateForCalendarNavigation()" :future_days="1" :past_days="2"></calendar-navigation>
            </div>
            <CollapseTransition>
                <div class="filters" v-if="showFilters">
                    <div class="advance">
                        <div class="filter-field">
                            <i class="filter-field__icon i-andy-calendar" aria-hidden="true"></i>
                            <select class="item date" v-model="filters.date" @change="changeDate()">
                                <option value="">{{ $t('label.traceability.filters.day') }}</option>
                                <option v-for="(value, key) in dates" :value="key" :key="key">{{ value }}</option>
                            </select>
                        </div>
                        <div class="filter-field expiration-time-field">
                            <i class="filter-field__icon i-andy-time-active" aria-hidden="true"></i>
                            <select class="item expiration-time" v-model="filters.expirationTime">
                                <option value="">{{ $t('label.traceability.filters.expiration_time') }}</option>
                                <option v-for="option in expirationTimeOptions" :value="option.id" :key="option.id">{{ $t(option.label) }}</option>
                            </select>
                        </div>
                        <!-- show datepicker if filters.date is custom -->
                        <localized-date-picker v-if="filters.date == 'custom'" class="date-input" :class="{ error: error.customDate }" v-model="customDate" />

                        <div class="filter-field">
                            <i class="filter-field__icon i-andy-filter2" aria-hidden="true"></i>
                            <select class="item state" v-model="filters.state">
                                <option value="">{{ $t('label.traceability.filters.statuses') }}</option>
                                <option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</option>
                            </select>
                        </div>
                        <div class="filter-field">
                            <i class="filter-field__icon i-andy-verify" aria-hidden="true"></i>
                            <select class="item category" v-model="filters.category">
                                <option value="">{{ $t('label.traceability.filters.category') }}</option>
                                <option v-for="category in categories" :value="category.id" :key="category.id">{{ category.name }}</option>
                            </select>
                        </div>
                        <div v-if="showRecordTypeFilter" class="filter-field">
                            <i class="filter-field__icon i-andy-menu-timer" aria-hidden="true"></i>
                            <select class="item record-type" v-model="filters.recordType">
                                <option value="">{{ $t('label.traceability.filters.label_format') }}</option>
                                <option value="physical">{{ $t('label.traceability.record_type_physical') }}</option>
                                <option value="timer">{{ $t('label.traceability.record_type_timer') }}</option>
                                <option value="both">{{ $t('label.traceability.record_type_both') }}</option>
                            </select>
                        </div>
                        <div class="item product">
                            <i class="filter-field__icon i-andy-search-aaaaa" aria-hidden="true"></i>
                            <input type="text" v-model="filters.product" :placeholder="$t('label.traceability.filters.search_by')" />
                            <div v-if="filters.product != ''" class="close" @click="cleanSearch()"></div>
                        </div>
                        <button type="button" class="item bttn" :class="{ disabled: !filterChanges }" :disabled="!filterChanges" @click="search(true)">
                            {{ $t('menu_aux.action.search') }}
                        </button>
                    </div>
                </div>
            </CollapseTransition>
            <div
                :key="key"
                class="list"
                ref="list"
                :class="[
                    { expanded: expanded, empty: viewMode === 'grid' && (results == 0 || offline || hasApiError), 'table-mode': viewMode === 'table' },
                    { 'filters-opened': showFilters },
                    { calendarOpened: calendarIsVisible && !showFilters }
                ]"
            >
                <TraceabilityTable
                    v-if="viewMode === 'table'"
                    :labels="labels"
                    :totalItems="results"
                    :pageNumber="page"
                    :itemsPerPage="num_items"
                    :totalLabel="paginationResultsLabel"
                    :showBy="showBy"
                    :loading="isLoading"
                    :offline="offline"
                    :hasApiError="hasApiError"
                    :showClearFiltersAction="hasAppliedFilters"
                    @row-click="previewLabel"
                    @previous-page="page_prev"
                    @next-page="page_next"
                    @page-change="goToPage"
                    @clear-filters="resetFilters"
                />
                <template v-else-if="isLoading"></template>
                <template v-else-if="offline">
                    <EmptyPage :title="$t('empty_pages.connection_description')" :description="$t('empty_pages.connection_title')" class="error"></EmptyPage>
                </template>
                <template v-else-if="hasApiError">
                    <EmptyPage type="error" :title="$t('empty_pages.api_error_title')" :description="$t('empty_pages.api_error_description')"></EmptyPage>
                </template>
                <template v-else>
                    <template v-if="results == 0">
                        <div class="empty-filter-state">
                            <EmptyPage :title="$t('empty_pages.generic_title')" :description="$t('empty_pages.label_description')"></EmptyPage>
                            <button v-if="hasAppliedFilters" type="button" class="clear-filters-button" @click="resetFilters">
                                <i class="i-andy-refresh" aria-hidden="true"></i>
                                {{ $t('assets.filter.delete') }}
                            </button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="cards">
                            <SingleLabel
                                v-for="(label, key) in labels"
                                :key="key"
                                :label="label"
                                show-traceability-kind
                                @click.native="previewLabel(label)"
                                :showBy="showBy"
                                type="preview"
                            ></SingleLabel>
                        </div>
                        <PaginationBar
                            compact
                            class="traceability-pagination"
                            :pageNumber="page"
                            :itemsPerPage="num_items"
                            :totalItems="results"
                            showPageNumbers
                            showTotal
                            :totalLabel="paginationResultsLabel"
                            @previous-page="page_prev"
                            @next-page="page_next"
                            @page-change="goToPage"
                        />
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { formatPrintedDateFromStore } from '@/utils/dateFormatters'
import Tabs from '../components/domain/ui/Tabs.vue'
import i18n from '@/i18n'
import { formatTraceabilityDate } from '@/utils/traceabilityExpiration'
import { resolveDateDisplayLocale } from '@/utils/dateInput'
import { gprinterStatusText } from '@/utils/gprinter/statusError'

function digitalLabelPrintError(response, label) {
    const specific = gprinterStatusText(response, function (key, params) {
        return i18n.t(key, params)
    })
    if (specific) {
        return specific
    }
    return i18n.tc('config.printer.error_print', 1).replace('[product]', label.data.product)
}
import Preview from '@/components/domain/label/preview.vue'
import ZplPreview from '@/components/domain/label/ZplPreview.vue'
import SingleLabel from '@/components/domain/label/singleLabel.vue'
import TraceabilityTable from '@/components/domain/label/TraceabilityTable.vue'
import EmptyPage from '../components/layout/EmptyPage.vue'
import Label from './Label.vue'
import CalendarNavigation from '@/components/layout/CalendarNavigation.vue'
import Button from '@/components/domain/ui/Button.vue'
import PaginationBar from '@/components/domain/ui/PaginationBar.vue'
import { CollapseTransition } from '@ivanv/vue-collapse-transition'
import { TOOLS } from '@/constants'
import { getPaginationTotalPages, normalizePaginationTotal, TRACEABILITY_ITEMS_PER_PAGE } from '@/utils/pagination'
import {
    buildZplPreviewState,
    createPrinterStoreAccessors,
    extractZPLFromPrinter as extractZPLFromPrinterUtil,
    isValidZPL as isValidZplString,
    resolveFormatForPrinterVariant as resolveFormatForPrintUtil
} from '@/utils/zplPreviewHelpers.js'

export default {
    name: 'DigitalLabel',
    components: { Preview, ZplPreview, SingleLabel, TraceabilityTable, EmptyPage, Label, CalendarNavigation, Tabs, Button, PaginationBar },
    data() {
        return {
            calendarIsVisible: false,
            viewMode: 'grid',
            date: 'today',
            dateBeforeFilters: null,
            filters: {
                date: '',
                state: '',
                category: '',
                recordType: '',
                expirationTime: '',
                product: ''
            },
            expirationTimeOptions: [
                { id: 'morning_shift', label: 'label.traceability.expiration_time_morning_shift' },
                { id: 'afternoon_shift', label: 'label.traceability.expiration_time_afternoon_shift' },
                { id: 'night_shift', label: 'label.traceability.expiration_time_night_shift' },
                { id: 'expired', label: 'label.traceability.expiration_time_expired' }
            ],
            dates: {
                today: i18n.t('label.filter.today'),
                yesterday: i18n.t('label.filter.yesterday'),
                week: i18n.t('label.filter.week'),
                month: i18n.t('label.filter.month'),
                quarter: i18n.t('label.filter.quarter'),
                custom: i18n.t('label.filter.select_day')
                // custom: i18n.t('label.filter.custom')
            },
            expanded: false,
            preview: false,
            print_date: false,
            offline: false,
            isLoading: false,
            hasApiError: false,
            num_items: TRACEABILITY_ITEMS_PER_PAGE,
            page: 1,
            showFilters: false,
            compareFilters: {
                date: '',
                state: '',
                category: '',
                recordType: '',
                expirationTime: '',
                product: ''
            },
            filterChanges: false,
            filterBy: 'tabOne',
            showBy: 'expiration_date',
            customDate: '',
            error: {
                customDate: false
            },
            key: 1,
            photosOfLabel: [],
            selectedPreview: 'label',
            showMore: false,
            selectedLabel: null,
            createdBy: false,
            isZplPreview: false,
            zpl: '',
            zplValues: {},
            zplParams: {},
            zplKey: 0,
            density: 203,
            labelWidth: 57,
            labelHeight: 51
        }
    },
    computed: {
        dateLocale() {
            const employee = this.$store.getters['loginUser/getUserInformation'] || {}
            const location = this.$store.getters['loginUser/getLocalLocation'] || {}
            return resolveDateDisplayLocale(this.$i18n.locale, this.$store.getters['login/getConfig'] || {}, employee.lang || employee.language, location.lang, this.$store.getters['intl/getLocale'])
        },
        canReprintLabel() {
            return this.$store.getters.canReprintLabel
        },
        categories() {
            const loginUser = this.$store.state.loginUser
            const localUser = loginUser && loginUser.local ? loginUser.local.user : null
            if (!localUser) {
                return []
            }
            return this.$store.getters['label/getSortedCategories']
        },
        states() {
            return this.$store.getters['label/getLabelStates']()
        },
        labels() {
            var labels = []
            var raw = this.$store.getters['label/getLabelsPrinted'].labels || {}
            for (var key in raw) {
                var label = raw[key]
                label.product = label.reference
                label.current_print_time = this.showBy == 'print_date' ? this.getPrintDateFromLabelData(label) : label.end_date
                label.traceabilityKind = this.resolveTraceabilityKind(label)
                labels.push(label)
            }

            // El API entrega el orden global. Reordenar sólo la página actual
            // rompería la continuidad visual entre páginas.
            return labels
        },
        isSummaryPhoto() {
            return this.selectedLabel && this.selectedLabel.summary && this.selectedLabel.summary.photo
        },
        photos: {
            set(newValue) {
                this.photosOfLabel = newValue
            },
            get() {
                return this.photosOfLabel
            }
        },
        results() {
            return normalizePaginationTotal(this.$store.getters['label/getLabelsPrinted'].results)
        },
        totalPages() {
            return getPaginationTotalPages(this.results, this.num_items)
        },
        paginationResultsLabel() {
            return this.$t('label.traceability.results')
        },
        enabledToolCodes() {
            return this.$store.getters['login/getEnabledToolCodes'] || []
        },
        hasLabelsTool() {
            return this.enabledToolCodes.includes(TOOLS.LABELS)
        },
        hasProductTimersTool() {
            return this.enabledToolCodes.includes(TOOLS.PRODUCT_TIMERS)
        },
        showRecordTypeFilter() {
            return this.hasLabelsTool && this.hasProductTimersTool
        },
        recordTypeFilterValue() {
            if (this.showRecordTypeFilter) {
                const typeMap = { physical: '1', timer: '2', both: '3' }
                return this.filters.recordType ? typeMap[this.filters.recordType] : ''
            }
            if (this.hasLabelsTool) {
                return '1'
            }
            if (this.hasProductTimersTool) {
                return '2'
            }
            return ''
        },
        hasAppliedFilters() {
            return ['date', 'state', 'category', 'recordType', 'expirationTime', 'product'].some((filter) => Boolean(this.compareFilters[filter]))
        }
    },
    methods: {
        displayTraceabilityDate(value) {
            return formatTraceabilityDate(value, this.dateLocale)
        },
        toggleViewMode() {
            this.viewMode = this.viewMode === 'grid' ? 'table' : 'grid'
        },
        getPrintDateFromLabelData(label) {
            try {
                const data = typeof label.data === 'string' ? JSON.parse(label.data) : label.data
                const v = data.print_date
                return v != null && v !== '' ? String(v) : ''
            } catch (e) {
                return ''
            }
        },
        resolveTraceabilityKind(label) {
            if (!label || typeof label !== 'object') {
                return 'physical'
            }
            const raw =
                label.record_type != null
                    ? label.record_type
                    : label.traceability_kind != null
                        ? label.traceability_kind
                        : label.traceability_record_type != null
                            ? label.traceability_record_type
                            : label.type
            if (raw === 'timer' || raw === 'product_timer' || raw === 2 || raw === '2') {
                return 'timer'
            }
            if (raw === 'both' || raw === 'physical_and_timer' || raw === 'mixed' || raw === 3 || raw === '3') {
                return 'both'
            }
            if (raw === 'physical' || raw === 'label' || raw === 'printed' || raw === 1 || raw === '1') {
                return 'physical'
            }
            if (label.is_product_timer === true || (label.is_timer && label.is_timer !== ' ')) {
                return 'timer'
            }
            if (label.is_product_timer === false) {
                return 'physical'
            }
            try {
                var data = typeof label.data === 'string' ? JSON.parse(label.data) : label.data
                if (data) {
                    if (data.is_timer && data.is_timer !== ' ') {
                        return 'timer'
                    }
                    if (data.is_product_timer) {
                        return 'timer'
                    }
                }
            } catch (e) {
                // ignore parse error
            }
            return ''
        },
        loadPrintedLabels(params) {
            const requestedPage = Number(params.number_pages) || 1
            this.isLoading = true
            this.hasApiError = false
            this.$overlay.loading()

            return this.$store.dispatch('label/loadLabelsPrinted', params)
                .then(() => {
                    if (requestedPage > 1 && this.labels.length === 0) {
                        this.page = 1
                        return this.$store.dispatch('label/loadLabelsPrinted', Object.assign({}, params, { number_pages: 1 }))
                    }
                    return true
                })
                .then(() => {
                    this.hasApiError = false
                    this.key++
                    this.$nextTick(() => {
                        var scroll = {
                            container: this.$refs.list,
                            target: document.querySelector('.elabel .list'),
                            offset: -400
                        }
                        if (scroll.container && scroll.target) {
                            this.$root.scrollTo(scroll)
                        }
                    })
                })
                .catch(() => {
                    this.hasApiError = true
                })
                .then(() => {
                    this.isLoading = false
                    this.$overlay.hide()
                })
        },
        switchShowFilters() {
            if (!this.showFilters && this.dateBeforeFilters === null) {
                this.dateBeforeFilters = this.formatDateForCalendarNavigation()
            }
            this.calendarIsVisible = false
            this.showFilters = !this.showFilters
        },
        showMoreOrLess() {
            this.showMore = !this.showMore
        },
        switchFilter(type) {
            let self = this
            this.page = 1
            let typeText = type == 'tabOne' ? 'end_date' : 'print_date'
            this.showBy = typeText
            this.filterBy = type === 'tabOne' ? 'tabOne' : 'tabTwo'
            var params = {
                start_date: this.date,
                end_date: this.date,
                date: this.filters.date != 'custom' ? this.filters.date : this.customDate,
                category: this.filters.category,
                states: this.filters.state,
                types: this.recordTypeFilterValue,
                expiration_time: this.filters.expirationTime,
                name: this.filters.product,
                number_pages: this.page,
                number_items: this.num_items,
                sort_type: typeText,
                sortType: self.showBy == 'print_date' ? 'desc' : 'asc'
            }
            this.loadPrintedLabels(params)
        },
        calendarState(show) {
            this.calendarIsVisible = show
        },
        formatDateForCalendarNavigation() {
            var date = this.date
            if (date == 'today') {
                return moment().format('YYYY-MM-DD')
            } else if (date == 'yesterday') {
                return moment().subtract(1, 'days').format('YYYY-MM-DD')
            } else if (date == 'week') {
                return moment().subtract(1, 'weeks').format('YYYY-MM-DD')
            } else if (date == 'month') {
                return moment().subtract(1, 'months').format('YYYY-MM-DD')
            } else if (date == 'quarter') {
                return moment().subtract(3, 'months').format('YYYY-MM-DD')
            } else {
                return moment(date).format('YYYY-MM-DD')
            }
        },
        load(refresh = true) {
            this.search()
            // If portrait, do not show filters expanded
            this.expanded = !['portrait'].includes(this.$mq)
            this.num_items = TRACEABILITY_ITEMS_PER_PAGE
        },
        cleanSearch() {
            this.filters.product = ''
        },
        resetFilters() {
            this.filters = {
                date: '',
                state: '',
                category: '',
                recordType: '',
                expirationTime: '',
                product: ''
            }
            this.customDate = ''
            this.date = this.dateBeforeFilters || this.date
            this.error.customDate = false
            this.search(true)
        },
        page_prev() {
            this.goToPage(this.page - 1)
        },
        page_next() {
            this.goToPage(this.page + 1)
        },
        goToPage(page) {
            const nextPage = Number(page)
            if (this.isLoading || !Number.isInteger(nextPage) || nextPage < 1 || nextPage > this.totalPages || nextPage === this.page) {
                return false
            }

            this.page = nextPage
            this.search()
        },
        changeDate(date = this.filters.date) {
            if (date && date !== 'custom') {
                this.date = date
            }
        },

        changeDateCalendar(date) {
            this.date = date
            this.dateBeforeFilters = null
            this.search(true)
        },

        search(resetPage = false) {
            if (resetPage) {
                this.page = 1
            }
            if (fnCheckConnection()) {
                this.offline = false
                var self = this
                if (!this.showFilters) {
                    this.filters.date = ''
                }
                if (this.showFilters) {
                    if (this.filters.date == 'custom') {
                        if (this.customDate == '') {
                            this.error.customDate = true
                            return
                        } else {
                            this.error.customDate = false
                            this.date = this.customDate
                        }
                    }
                    if (this.filters.product.length > 0 && this.filters.product.length < 3) {
                        // snackbar
                        return this.$snackbar.error({ closeable: true, message: i18n.t('label.filter.error') })
                    }
                }
                var params = {
                    start_date: this.date,
                    end_date: this.date,
                    date: this.filters.date != 'custom' ? this.filters.date : this.customDate,
                    category: this.filters.category,
                    states: this.filters.state,
                    types: this.recordTypeFilterValue,
                    expiration_time: this.filters.expirationTime,
                    name: this.filters.product,
                    number_pages: this.page,
                    number_items: this.num_items,
                    sort_type: this.showBy,
                    sortType: self.showBy == 'print_date' ? 'desc' : 'asc'
                }
                this.loadPrintedLabels(params)
                this.compareFilters.date = this.filters.date
                this.compareFilters.category = params.category
                this.compareFilters.state = params.states
                this.compareFilters.recordType = this.filters.recordType
                this.compareFilters.expirationTime = params.expiration_time
                this.compareFilters.product = params.name
            } else {
                this.offline = true
            }
        },
        fnClosePreview() {
            this.preview = false
            this.isZplPreview = false
            this.selectedLabel = null
            this.key++
        },
        printerStoreAccessors() {
            return createPrinterStoreAccessors(this.$store)
        },
        isValidZPL(zpl) {
            return isValidZplString(zpl)
        },
        resolveFormatForPrint(formatId) {
            return resolveFormatForPrintUtil(formatId, this.printerStoreAccessors())
        },
        extractZPLFromPrinter(format, printer) {
            return extractZPLFromPrinterUtil(format, printer, this.printerStoreAccessors())
        },
        openZplPreview({ zpl, format, labelName, params, resolvedPreviewFields }) {
            const state = buildZplPreviewState({ zpl, format, labelName, params, resolvedPreviewFields })
            this.zpl = state.zpl
            this.density = state.density
            this.labelWidth = state.labelWidth
            this.labelHeight = state.labelHeight
            this.zplValues = state.zplValues
            this.zplParams = state.zplParams
            this.zplKey++
        },
        previewLabel(label) {
            //TODO: add photo label
            var reference = this.$store.getters['label/getLabel'](label.reference)
            const formatId = reference.states[label.state] ? reference.states[label.state].format : null
            var format = this.resolveFormatForPrint(formatId)
            if (!format || !format.data) {
                this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
                return
            }
            var values = JSON.parse(format.data)
            log('--- previewLabel ---')
            log('label', label)
            log('reference', reference)
            log('format', format)
            this.selectedLabel = label

            if (label.preview) {
                try {
                    var params = JSON.parse(label.data)
                    var oLocation = this.$store.getters['loginUser/getLocalLocation']
                    params['account'] = oLocation.account_name
                    params['location'] = oLocation.name
                    params['quantity'] = label.quantity
                    params['city'] = oLocation.city
                    params['address'] = oLocation.address
                    params['loc_state'] = oLocation.state
                    params['cp'] = oLocation.cp

                    if (params && params.photo && params.photo.length > 0) {
                        this.photos = [...params.photo]
                    }

                    if (typeof params.bUpdatedPrintDate != 'undefined' && params.bUpdatedPrintDate) {
                        params.print_date += ' *'
                        params.print_date_time += ' *'
                        params.print_date_day += ' *'
                    }
                    
                    var printer = Object.keys(this.$store.getters['printer/getPrinter']).length > 0 ? this.$store.getters['printer/getPrinter'] : this.$store.getters['login/getPrinter']
                    var extracted = this.extractZPLFromPrinter(format, printer)
                    var zpl = extracted && extracted.zpl ? extracted.zpl : null
                    var labelName = extracted && extracted.labelName ? extracted.labelName : null
                    log('previewLabel -> zpl', zpl)
                    log('previewLabel -> labelName', labelName)
                    log('previewLabel -> params', params)
                    log('previewLabel -> format', format)
                    log('previewLabel -> printer', printer)
                    log('previewLabel -> extracted', extracted)

                    let previewParsed = null
                    try {
                        previewParsed = typeof label.preview === 'string' ? JSON.parse(label.preview) : label.preview
                    } catch (ignorePreviewParse) {
                        previewParsed = null
                    }

                    if (previewParsed && previewParsed.fields) {
                    for (var key in previewParsed.fields) {
                        var field = previewParsed.fields[key]
                        var value = typeof field.f_id !== 'undefined' ? values[field.f_id] : field.value
                        const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                        let m
                        let aux_value = value
                        while ((m = regex.exec(value)) !== null) {
                            // This is necessary to avoid infinite loops with zero-width matches
                            if (m.index === regex.lastIndex) {
                                regex.lastIndex++
                            }

                            // The result can be accessed through the `m`-variable.
                            m.forEach((match, groupIndex) => {
                                var m_index = match.replace(/[\{\}\[\]]/gi, '')
                                let name = this.$t('label.preview.' + m_index)
                                if (name.indexOf('label.preview.') != -1) {
                                    name = m_index
                                }
                                log('Match: ', match)
                                log('Index: ', m_index)
                                if (!Object.keys(params).includes(m_index)) {
                                    const regex2 = /(_d[0-9]|_day|_timestamp|_time)/gi
                                    let n
                                    while ((n = regex2.exec(m_index)) !== null) {
                                        // This is necessary to avoid infinite loops with zero-width matches
                                        if (n.m_index === regex2.lastIndex) {
                                            regex2.lastIndex++
                                        }

                                        // The result can be accessed through the `m`-variable.
                                        n.forEach((match2, groupIndex) => {
                                            var keyValue = m_index.replace(match2, '')
                                            if (Object.keys(params).includes(keyValue)) {
                                                var d = moment(params[keyValue], 'DD/MM/YYYY HH:mm')
                                                if (!d.isValid()) {
                                                    d = moment(parseInt(params[keyValue]) * 1000)
                                                }
                                                params[keyValue + '_day'] = d.format('DD/MM/YYYY')
                                                params[keyValue + '_time'] = d.format('HH:mm')
                                                params[keyValue + '_timestamp'] = parseInt(d.valueOf() / 1000).toString()
                                                params[keyValue + '_d1'] = d.isoWeekday() == 1 ? 'x' : ' '
                                                params[keyValue + '_d2'] = d.isoWeekday() == 2 ? 'x' : ' '
                                                params[keyValue + '_d3'] = d.isoWeekday() == 3 ? 'x' : ' '
                                                params[keyValue + '_d4'] = d.isoWeekday() == 4 ? 'x' : ' '
                                                params[keyValue + '_d5'] = d.isoWeekday() == 5 ? 'x' : ' '
                                                params[keyValue + '_d6'] = d.isoWeekday() == 6 ? 'x' : ' '
                                                params[keyValue + '_d7'] = d.isoWeekday() == 7 ? 'x' : ' '
                                            } else if (Object.keys(params).includes(keyValue + '_timestamp')) {
                                                var d = moment(parseInt(params[keyValue + '_timestamp']) * 1000)
                                                params[keyValue + '_day'] = d.format('DD/MM/YYYY')
                                                params[keyValue + '_time'] = d.format('HH:mm')
                                                params[keyValue] = d.format('DD/MM/YYYY HH:mm')
                                                params[keyValue + '_d1'] = d.isoWeekday() == 1 ? 'x' : ' '
                                                params[keyValue + '_d2'] = d.isoWeekday() == 2 ? 'x' : ' '
                                                params[keyValue + '_d3'] = d.isoWeekday() == 3 ? 'x' : ' '
                                                params[keyValue + '_d4'] = d.isoWeekday() == 4 ? 'x' : ' '
                                                params[keyValue + '_d5'] = d.isoWeekday() == 5 ? 'x' : ' '
                                                params[keyValue + '_d6'] = d.isoWeekday() == 6 ? 'x' : ' '
                                                params[keyValue + '_d7'] = d.isoWeekday() == 7 ? 'x' : ' '
                                            }
                                        })
                                    }

                                    if (!Object.keys(params).includes(m_index)) {
                                        params[m_index] = ''
                                    }
                                }

                                if (m_index != '' && Object.keys(params).includes(m_index)) {
                                    aux_value = aux_value.replace(match, params[m_index])
                                }
                            })
                        }

                        if (field.format && field.type !== 'barcode') {
                            aux_value = formatPrintedDateFromStore(aux_value, field.format)
                        } else if (field.format && !moment(aux_value, field.format, true).isValid()) {
                            const formats = ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY']
                            let bConverted = false
                            formats.forEach((formatValidate) => {
                                let formatRegex = formatValidate.replace('DD', '\\d{2}').replace('MM', '\\d{2}').replace('YYYY', '\\d{4}').replace('HH', '\\d{2}').replace('mm', '\\d{2}').replace('ss', '\\d{2}').replace(/\s/g, '\\s')
                                const regexFmt = new RegExp(`^.*${formatRegex}.*$`)
                                if (regexFmt.test(aux_value) && !bConverted) {
                                    const aux2 = aux_value.replace(moment(aux_value, formatValidate).format(formatValidate), '{date}')
                                    const dateStr = moment(aux_value, formatValidate).format(field.format)
                                    aux_value = aux2.replace('{date}', dateStr)
                                    bConverted = true
                                }
                            })
                            if (field.format && !moment(aux_value, field.format, true).isValid()) {
                                const d = moment(aux_value, 'DD/MM/YYYY HH:mm', true)
                                aux_value = d.isValid() ? d.format(field.format) : aux_value
                            }
                        }

                        previewParsed.fields[key].value = aux_value
                    }
                    }

                    if (zpl && this.isValidZPL(zpl)) {
                        this.openZplPreview({
                            zpl,
                            format,
                            labelName,
                            params,
                            resolvedPreviewFields:
                                previewParsed && previewParsed.fields ? previewParsed.fields : undefined
                        })
                        this.preview = {}
                        this.isZplPreview = true
                        this.print_date = params.print_date
                        this.createdBy = params.employee_name
                        this.$snackbar.close()
                        return
                    }

                    this.isZplPreview = false
                    if (previewParsed) {
                        this.preview = previewParsed

                        this.$snackbar.close()

                        this.print_date = params.print_date
                        this.createdBy = params.employee_name
                    } else {
                        this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
                    }
                } catch (e) {
                    this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
                }
            } else {
                this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
            }
        },
        selectPreview(preview) {
            this.selectedPreview = preview
        },
        reprintLabel() {
            var self = this
            let label = JSON.parse(JSON.stringify(this.selectedLabel))
            console.log('reprintLabel -> label', label)
            let printData = []
            const productState = this.$store.getters['label/getStateByLabel'](label.product, label.state)
            log('productState', productState)
            const formatId = productState.format
            log('formatId', formatId)
            var current_config = this.$store.getters['printer/getCurrentPrinter']
            var currentPrinterConfig = this.$store.getters['printer/getPrinterConfig'](current_config)
            log('currentPrinterConfig', currentPrinterConfig)
            const format = this.resolveFormatForPrint(formatId)
            if (!format || !format.data) {
                this.$snackbar.error({
                    closeable: true,
                    message: this.$t('config.printer.windows.errorTplPath')
                })
                return
            }
            var formatValues = JSON.parse(format.data)
            log('formatValues', formatValues)
            var newPreviewStructure = format.realistic_preview ? JSON.parse(format.realistic_preview) : false
            log('newPreviewStructure', newPreviewStructure)

            let dates = ['print_date', 'date', 'prep_date', 'caducidad']
            label.data = JSON.parse(label.data)
            let ingredientes = ['ingr', 'recep']

            for (var field in formatValues) {
                var value = formatValues[field]

                if (value) {
                    let aux = value

                    let start = aux.indexOf('[') > -1 ? aux.indexOf('[') : aux.indexOf('{')
                    start++
                    let end = aux.indexOf(']') > -1 ? aux.indexOf(']') : aux.indexOf('}')
                    let keyValue = aux.substring(start, end)
                    let oldKeyValue = aux.substring(start, end)

                    let suffixes = ['_day', '_timestamp', '_time', '_datetime', '_d1', '_d2', '_d3', '_d4', '_d5', '_d6', '_d7', '_wd', '_wd1', '_wd2', '_wd3', '_wd4', '_wd5', '_wd6', '_wd7']
                    let param = keyValue
                    for (let suffix of suffixes) {
                        if (keyValue.includes(suffix)) {
                            param = keyValue.replace(suffix, '')
                            break
                        }
                    }

                    if (param != '' && (dates.includes(param) || ingredientes.some(ingr => param.includes(ingr)))) {
                        //TODO keyValue puede tener muchos sufijos, entonces necesito obtener la key que incluye en date. For example if keyValue is caducidad_day get caducidad, but this can be other options like caducidad_timestamp, caducidad_time

                        let aux = moment(label.data[param + '_timestamp'] * 1000)
                        label.data[param + '_day'] = aux.format('DD/MM/YYYY')
                        label.data[param + '_time'] = aux.format('HH:mm')
                        label.data[param + '_datetime'] = aux.format('DD/MM/YYYY HH:mm')
                        label.data[param + '_timestamp'] = parseInt(aux.valueOf() / 1000).toString()
                        label.data[param + '_d1'] = aux.isoWeekday() == 1 ? 'x' : ' '
                        label.data[param + '_d2'] = aux.isoWeekday() == 2 ? 'x' : ' '
                        label.data[param + '_d3'] = aux.isoWeekday() == 3 ? 'x' : ' '
                        label.data[param + '_d4'] = aux.isoWeekday() == 4 ? 'x' : ' '
                        label.data[param + '_d5'] = aux.isoWeekday() == 5 ? 'x' : ' '
                        label.data[param + '_d6'] = aux.isoWeekday() == 6 ? 'x' : ' '
                        label.data[param + '_d7'] = aux.isoWeekday() == 7 ? 'x' : ' '

                        for (let i = 0; i < 4; i++) {
                            let day = i18n.t('calendar.days')[aux.day()].toUpperCase()
                            if (i > 0) {
                                label.data[param + '_wd' + i] = day.slice(0, i)
                            } else {
                                label.data[param + '_wd'] = day
                            }
                        }
                    }

                    while (keyValue) {
                        // console.log('KEYVALUE: ', keyValue)
                        keyValue = keyValue.replace('[', '').replace(']', '').replace('{', '').replace('}', '')
                        aux = aux.replace('[', '').replace(']', '').replace('{', '').replace('}', '')

                        // console.log(keyValue, aux, Object.assign({}, self.oParams), self.oParams[keyValue])
                        // if (!self.oParams[keyValue]) {
                        //     self.oParams[keyValue] = aux
                        // }
                        // console.log(keyValue, aux, Object.assign({}, self.oParams), self.oParams[keyValue])

                        // let newValue = self.oParams[keyValue] // cleanString(self.oParams[keyValue])
                        // if (newValue.indexOf(oldKeyValue) != -1) {
                        //     newValue = newValue.replace(oldKeyValue, '')
                        //     self.oParams[keyValue] = newValue
                        // }
                        aux = aux.replace(keyValue, label.data[keyValue])

                        if (newPreviewStructure) {
                            newPreviewStructure.fields.forEach((el) => {
                                if (el.f_id && el.f_id == field) {
                                    if (el.format && el.type === 'barcode') {
                                        aux = moment(aux, 'DD/MM/YYYY HH:mm').format(el.format)
                                    }
                                } else if (!el.f_id && el.value == value && el.format && el.type === 'barcode') {
                                    aux = moment(aux, 'DD/MM/YYYY HH:mm').format(el.format)
                                }
                            })
                        }

                        if (['print_date', 'print_date_time', 'print_date_day'].includes(keyValue) && false) {
                            aux += ' *'
                        }

                        start = aux.indexOf('[') > -1 ? aux.indexOf('[') : aux.indexOf('{')
                        start++
                        end = aux.indexOf(']') > -1 ? aux.indexOf(']') : aux.indexOf('}')
                        keyValue = aux.substring(start, end)
                        oldKeyValue = aux.substring(start, end)
                    }
                    const previewField = newPreviewStructure && newPreviewStructure.fields.find(el => el.f_id ? el.f_id == field : el.value == value)
                    if (previewField && previewField.format && previewField.type !== 'barcode') {
                        aux = formatPrintedDateFromStore(aux, previewField.format)
                    }
                    var data = aux // cleanString(aux)
                    data = data.trim() == '' ? ' ' : data
                    printData.push({ k: field, v: data })
                } else {
                    printData.push({ k: field, v: ' ' })
                }
            }

            log('printData', printData)

            self.$overlay.loading()
            this.$store
                .dispatch('printer/printLabel', {
                    printData: printData,
                    num_copies: 1,
                    context: {
                        config: current_config,
                        printer: currentPrinterConfig.model,
                        template: format.id,
                        label: format.label_id
                    }
                })
                .then(function (response) {
                    console.log('reprintLabel -> response', response)
                    if (typeof response == 'undefined' || (response.status && response.status == 'success')) {
                        let msg = i18n.tc('config.printer.success_window_print', 1)
                        msg = msg.replace('[product]', label.data.product)
                        self.$snackbar.progress({
                            closeable: true,
                            message: msg
                        })
                        self.$overlay.hide()
                    } else {
                        let msg = digitalLabelPrintError(response, label)
                        self.$snackbar.error({
                            closeable: true,
                            message: msg
                        })
                        self.$overlay.hide()
                    }
                })
                .catch((response) => {
                    let msg = digitalLabelPrintError(response, label)
                    self.$snackbar.error({
                        closeable: true,
                        message: msg
                    })
                    self.$overlay.hide()
                })
        },
        isExpiredDate(dateString, dateStartString) {
            if (!moment(dateString, 'YYYY-MM-DD HH:mm').isValid()) {
                const datePart = moment(dateStartString, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
                dateString = `${datePart} 23:59`
            }

            return moment(dateString, 'YYYY-MM-DD HH:mm').isBefore(moment().format('YYYY-MM-DD HH:mm'))
        }
    },
    created() {
        this.load()
    },
    activated() {
        this.viewMode = 'grid'
    },
    beforeRouteLeave(to, from, next) {
        this.viewMode = 'grid'
        this.$snackbar.close()
        this.$popup.close()
        next()
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                if (JSON.stringify(this.filters) != JSON.stringify(this.compareFilters)) {
                    this.filterChanges = true
                } else {
                    this.filterChanges = false
                }
            },
            deep: true
        },
        compareFilters: {
            handler: function (val, oldVal) {
                if (JSON.stringify(this.filters) != JSON.stringify(this.compareFilters)) {
                    this.filterChanges = true
                } else {
                    this.filterChanges = false
                }
            },
            deep: true
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#content.elabel {
    padding: 10px;
    .full-preview {
        @include display-flex();
        @include justify-content();
        @include align-items(center);
        @include flex-direction(column);
        width: 100%;
        height: 100%;

        .preview-container {
            width: 100%;
            @include display-flex();
            @include justify-content(space-around);
            @include flex-direction(row);

            .gallery-box {
                @include display-flex();
                @include justify-content();
                @include align-items(center);
                @include flex-direction(column);
                gap: 16px;
                .main-image {
                    @include border-radius();
                    overflow: hidden;
                    width: 455px;
                    height: 518px;

                    &.label {
                        width: auto;
                        height: auto;
                    }

                    &.zpl {
                        max-width: 400px;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .thumb-img {
                    @include display-flex();
                    @include justify-content();
                    @include align-items(center);
                    gap: 8px;

                    .images-boxes {
                        width: 80px;
                        height: 80px;
                        background: $main-dark;
                        @include border-radius();
                        position: relative;
                        overflow: hidden;
                        border: solid 1px $color-neutral-300;
                        cursor: pointer;
                        box-sizing: border-box;

                        &.selected {
                            border: solid 3px $color-primary-500;
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }

                        &.label {
                            &::after {
                                content: '';
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                width: 60px;
                                height: 60px;
                                transform: translate(-50%, -50%);
                                @include background($image: img('menu_elabel_light.svg'), $position: center center);
                            }
                        }
                    }
                }
            }

            .summary-box {
                .info-summary {
                    width: 400px;
                    //@include default-box-shadow();
                    background: $color-white;
                    padding: 1rem 2rem;
                    @include border-radius(4px);
                    font-family: $text-sbold;
                    @include font-size(16px);
                    text-align: start;

                    .date {
                        font-family: $text-sbold;
                        text-align: start;
                    }
                }
            }
        }

        .btn-close {
            @include border-radius(4px);
            @include interaction;
            background-color: #fff;
            opacity: 0.7;
            margin-top: 25px;
            padding: 10px 20px;
            color: #444;
            font-family: $text-sbold;

            @include bgHover(darken(#fff, 5%));
        }

        .close-preview {
            position: absolute;
            @include background($image: img('minimize.svg'), $position: center center, $size: 20px, $color: #fff);
            @include border-radius(4px);
            @include interaction();
            width: 40px;
            height: 40px;
            top: 20px;
            right: 20px;
        }

        .date {
            @include font-size(s);
            font-family: $text-light;
            color: $neutro-s80;
            width: 100%;
            display: inline-block;
            bottom: 0px;
            padding: 10px 0;
            text-align: center;
        }
    }
    .header-container {
        width: 100%;
        height: 45px;
        @include display-flex();
        @include justify-content(space-between);
        @include align-items(center);

        .traceability-selector {
            @include display-flex();
            @include justify-content(space-between);
            @include align-items(center);
            @include border-radius(4px);
            flex: 1;
            min-width: 0;
            height: 45px;
            padding: 3px;
        }
        .header-actions {
            @include display-flex();
            @include align-items(center);
            gap: 8px;
            margin-left: 8px;
            flex-shrink: 0;

            .search,
            .view-mode-toggle {
                @include border-radius(4px);
                height: 45px;
                width: 45px;
                min-height: 45px;
                min-width: 45px;
                cursor: pointer;
            }

            .search {
                @include background($image: img('search_neutro_s50.svg'), $color: #fff, $size: 20px);

                &.selected {
                    @include background($image: img('search_light.svg'), $color: $main-dark, $size: 20px);
                }
            }

            .view-mode-toggle {
                position: relative;
                padding: 0;
                border: 0;
                outline: none;
                background-color: #fff;

                &.view-table {
                    @include background($image: img('list_neutro_s50.svg'), $color: #fff, $size: 25px);
                }

                &.view-grid {
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    color: #727477;
                }

            }
        }
    }
    .calendar-navigation-container {
        padding-top: 8px;
    }
    .filter-btn {
        @include display-flex();
        @include justify-content();
        @include align-items();
        @include background($image: img('filter_elabel.svg'), $position: left center, $size: 30px);
        @include font-size(sm);
        @extend .interaction;
        color: $neutro-s80;
        width: fit-content;
        font-family: $text-thin;
        height: 50px;
        padding: 20px 40px;
        margin: 0 auto;
        transition-duration: 0.2s;
    }

    .slide-fade-enter-active {
        transition: all 0.2s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.2s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(-50px);
        opacity: 0;
    }

    .filters {
        overflow: hidden;

        .filter-field {
            height: 40px;
            min-width: 0;
            position: relative;

            &::after {
                border-bottom: 1.5px solid #b6b9be;
                border-right: 1.5px solid #b6b9be;
                content: '';
                height: 10px;
                pointer-events: none;
                position: absolute;
                right: 11px;
                top: 50%;
                transform: translateY(-50%) rotate(45deg);
                width: 10px;
                z-index: 1;
            }

            &__icon {
                color: #b6b9be;
                font-size: 20px;
                left: 8px;
                pointer-events: none;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
            }
        }

        .item {
            @include border-radius(5px);
            padding: 8px 29px 8px 36px;
            width: 100%;
            border: none;
            height: 40px;
            line-height: 24px;
            display: block;
            background-color: #fff;
            position: relative;
            cursor: pointer;
            font-family: $text-bold;
            font-size: 16px;
            color: $neutro-s80;

            &.expiration-time {
                @include font-size(sm);
                appearance: none;
                background-color: #fff;
                box-sizing: border-box;
                font-family: $text-bold;
                line-height: 24px;
                margin: 0;
            }
            &.expand {
                width: 45px;
                background: #fff;
                padding: 0;
                @include background($image: img('down_dark.svg'), $position: center, $size: 25px);
                float: right;
                display: none;

                &.expanded {
                    @include background($image: img('up_dark.svg'), $position: center, $size: 25px);
                }
            }
            &.product {
                padding-right: 8px;

                .filter-field__icon {
                    color: #b6b9be;
                    font-size: 20px;
                    left: 8px;
                    pointer-events: none;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 1;
                }

                input {
                    width: 100%;
                    float: left;
                    border: none;
                    padding: 0;
                    height: 24px;
                    line-height: 24px;
                    margin: 0;
                    font-family: $text;
                    color: $neutro-s80;
                    cursor: text;
                    @include font-size(sm);
                }

                .close {
                    float: left;
                    @include border-radius(4px);
                    @include background($image: img('close_dark.svg'), $size: 12px, $position: center center);
                    width: 28px;
                    height: 28px;
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    background-color: $neutro-t50;
                    cursor: pointer;
                }
            }
            &.bttn {
                background: $main;
                text-align: center;
                color: #fff !important;
                padding: 8px;
                font-family: $text-bold !important;

                &.disabled {
                    background-color: $main-t80 !important;
                    cursor: not-allowed;
                    color: $main-t40 !important;
                    font-family: $text-bold !important;
                    pointer-events: none;
                }
            }
        }

        select.item {
            appearance: none;
            box-sizing: border-box;
            background-color: #fff;
            background-image: none;
            line-height: 24px;
        }

        .advance {
            padding-top: 6px;
            padding-bottom: 5px;
            display: grid;
            gap: 10px;
            grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
            height: auto;
            grid-template-rows: 40px;
            width: 100%;
        }
    }

    .list {
        height: calc(100% - 93px);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding-top: 8px;

        .cards {
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: auto;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            align-content: start;
            column-gap: 16px;
            row-gap: 16px;
            align-items: stretch;
        }

        .traceability-pagination {
            flex: 0 0 auto;
            margin-top: 8px;
        }

        @media (max-width: 1200px) {
            // grid-template-columns: 1fr 1fr;
        }

        &.empty {
            display: flex !important;
            align-items: center;
            justify-content: center;
            min-height: 0;
            overflow: hidden;
        }

        &.filters-opened {
            height: calc(100% - 190px);
        }
        &.calendarOpened {
            height: calc(100% - 500px);
        }
    }

    .empty-filter-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        width: 100%;
        height: 100%;
        min-height: 0;

        ::v-deep .empty-container {
            flex: 0 1 auto;
            height: auto;
        }
    }

    .clear-filters-button {
        @include border-radius(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 166px;
        height: 36px;
        min-height: 36px;
        padding: 8px;
        border: 0;
        background-color: #edeff5;
        color: #374673;
        cursor: pointer;
        font-family: $text-bold;
        font-size: 18px;
        line-height: 18px;

        .i-andy-refresh {
            color: #374673;
            flex: 0 0 20px;
            width: 20px;
            height: 20px;
            font-size: 20px;
            line-height: 20px;
        }
    }
    &.landscape {
    }
    &.desktop {
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss" scoped>
.portrait #content.elabel {
    padding: 10px;
    .header-container {
        .traceability-selector {
            .text {
                @include font-size(s);
            }
        }
    }
    .full-preview {
        padding: 10px 0;
        padding-top: 70px;

        .date {
            // width: calc(100% - 40px);
            // display: inline-block;
            // position: absolute;
            // left: 20px;
            // top: 20px;
            // padding: 10px 0;
            // text-align: left;
        }

        .preview-container {
            @include flex-direction(column-reverse);
            @include justify-content(space-around);
            gap: 8px;
            height: 100%;
            min-height: 0;

            .gallery-box {
                @include flex-direction(column);
                flex: 1;
                min-height: 0;
                overflow: hidden;

                .main-image {
                    width: 370px;
                    height: 442px;

                    &.label {
                        width: 100%;
                        max-width: 100%;
                        height: 100%;
                        min-height: 0;
                        flex: 1;
                        @include display-flex();
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .thumb-img {
                    @include display-flex();
                    @include justify-content();
                    @include align-items(center);
                    gap: 8px;

                    .images-boxes {
                        width: 60px;
                        height: 60px;

                        &.label {
                            &::after {
                                width: 40px;
                                height: 40px;
                            }
                        }
                    }
                }
                .reprint-button {
                    width: 100%;
                }
            }

            .summary-box {
                .text-box {
                    max-height: 40px;
                    overflow: hidden;

                    &.expand {
                        max-height: unset;
                    }
                }
                .show-more-container {
                    @include display-flex();
                    @include justify-content(flex-end);
                    .show-more-less {
                        color: $color-neutral-600;
                        text-align: right;
                        cursor: pointer;
                        @include font-size(14px);
                    }
                }

                .info-summary {
                    width: auto;
                    padding: 16px;
                    @include border-radius(4px);
                    font-family: $text-sbold;
                    @include font-size(12px);
                    text-align: start;

                    .date {
                        font-family: $text-sbold;
                        text-align: start;
                        @include font-size(14px);
                    }
                }
            }
        }
    }
    .filter-btn {
        @include display-flex();
        @include justify-content();
        @include align-items();
        @include background($image: img('filter_elabel.svg'), $position: left center, $size: 30px);
        @include font-size(sm);
        @extend .interaction;
        color: $neutro-s80;
        width: fit-content;
        font-family: $text-light;
        height: 50px;
        padding: 20px 40px;
        margin: 0 auto;
        transition-duration: 0.2s;
    }

    .slide-fade-enter-active {
        transition: all 0.2s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.2s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(-50px);
        opacity: 0;
    }
    .filters {
        padding-top: 0px;

        .filter-field {
            height: 40px;
            margin: 5px 0;

            .item {
                margin: 0;
            }
        }

        .item {
            font-size: 16px;
            line-height: 24px;
            width: 100%;
            max-width: 100%;
            margin: 5px 0;
            font-family: $text-bold;
            color: $neutro-s80;

            &.expand {
                width: 45px;
                display: block;
            }
        }
        .advance {
            display: block;
            width: 100%;
            margin-top: 10px;
            float: left;

            .date-input {
                @include border-radius(4px);
                @include font-size(s);
                width: 60%;
                height: 40px;
                box-sizing: border-box;
                padding: 8px;
                border: 1px solid $default-sec-color;
                color: $neutro-s80;
                font-family: $text-bold;
                margin-right: 6px;

                &:focus {
                    outline: none;
                    border: 1px solid $default-sec-color;
                }

                &::placeholder {
                    color: $neutro-s80;
                }

                &.error {
                    border: 1px solid $error_dark;
                }
            }
        }
    }

    .list {
        height: calc(100% - 40px);
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .cards {
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: auto;
            display: grid;
            grid-template-columns: 1fr;
            align-content: start;
            column-gap: 6px;
            row-gap: 6px;
            align-items: stretch;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        &.expanded {
            height: calc(100% - 103px);
        }
        &.filters-opened {
            height: calc(100% - 355px);

            &.calendarOpened {
                height: calc(100% - 745px);
            }
        }
        &.calendarOpened {
            height: calc(100% - 500px);
        }

        &.empty {
            display: flex !important;
            align-items: center;
            justify-content: center;
            min-height: 0;
            overflow: hidden;
        }
    }

}

.portrait #content.elabel,
.landscape #content.elabel,
.desktop #content.elabel {
    padding: 10px;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .header-container,
    .calendar-navigation-container {
        flex: 0 0 auto;
    }

    .filters {
        flex: 0 1 auto;
        min-height: 0;
        overflow-y: auto;
        max-height: calc(100% - 150px);
    }

    .full-preview {
        padding: 10px 0;
        padding-top: 70px;

        .date {
            // width: calc(100% - 40px);
            // display: inline-block;
            // position: absolute;
            // left: 20px;
            // top: 20px;
            // padding: 10px 0;
            // text-align: left;
        }
    }

    .list {
        flex: 1 1 auto;
        height: auto;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        &.expanded,
        &.filters-opened,
        &.calendarOpened {
            height: auto;
        }

        .cards {
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: auto;
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            align-content: start;
            column-gap: 15px;
            row-gap: 15px;
            align-items: stretch;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        &.empty {
            display: flex !important;
            align-items: center;
            justify-content: center;
            min-height: 0;
            overflow: hidden;
        }

    }

    .summary-box {
        display: flex;
        flex-direction: column;

        .reprint-button {
            margin-top: auto;
        }
    }
}

.portrait #content.elabel .list .cards {
    grid-template-columns: 1fr;
    gap: 6px;
}

.desktop #content.elabel {
    .list .cards {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        column-gap: 16px;
        row-gap: 16px;
    }
}

#content.elabel .list.table-mode {
    display: block;
    grid-template-columns: none;
    gap: 0;
    overflow: hidden;
}
</style>
